import { z } from "zod";

export interface LizardPaginated<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export function paginatedSchema(listItemSchema: z.Schema) {
  return z.object({
    count: z.number(),
    next: z.string().nullable(),
    previous: z.string().nullable(),
    results: z.array(listItemSchema),
  });
}

export function geojsonPaginatedSchema(featureSchema: z.Schema) {
  return z.object({
    count: z.number(),
    next: z.string().nullable(),
    previous: z.string().nullable(),
    results: z.object({
      type: z.literal("FeatureCollection"),
      features: z.array(featureSchema),
    }),
  });
}
